module.exports = __webpack_public_path__ + "static/media/20150903_114155.d06ecb41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20150903_114155.jpg
// module id = 444
// module chunks = 0